import {
    $createParagraphNode, $createTextNode,
    $getRoot,
} from "lexical"
import {ContentRTF, RTFVersion} from "../@type"
import lexical_convertFromMarkdown from "./convert-from-markdown"

// const debug = "lexicalGetInitialEditorState"
const debug = false

export function lexicalGetInitialEditorState(
    messageText?    : string,
    messageRTF?     : ContentRTF
): any {

    let res
    if (messageRTF) {
        if (!messageRTF.content && messageRTF.v === RTFVersion.CLICKUP_IMPORT && !!messageRTF.importOriginal) {
            res = function() {
                lexical_convertFromMarkdown(messageRTF.importOriginal)
            }
        } else {
            res = JSON.stringify(messageRTF.content)
        }
    } else if (messageText) { // add text if no messageRTF and messageText is passed
        res = function (){
            const root = $getRoot();
            if (root.getFirstChild() === null) {
                const paragraph = $createParagraphNode();
                paragraph.append(
                    $createTextNode(messageText)
                )
                root.append(paragraph)
            }
        }
    }

    return res
}